import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=fab239ec&scoped=true"
import script from "./deleteModal.vue?vue&type=script&lang=js"
export * from "./deleteModal.vue?vue&type=script&lang=js"
import style0 from "./deleteModal.vue?vue&type=style&index=0&id=fab239ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab239ec",
  null
  
)

export default component.exports